"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*!
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * Licensed under the Amazon Software License (the "License"). You may not use this file except in compliance with the License. A copy of
 * the License is located at
 *     http://aws.amazon.com/asl/
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, express or implied. See the License for the specific language governing permissions and limitations under the License.
 */
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var apollo_link_http_1 = require("apollo-link-http");
var apollo_utilities_1 = require("apollo-utilities");
var redux_1 = require("redux");
var redux_offline_1 = require("@redux-offline/redux-offline");
var defaults_1 = require("@redux-offline/redux-offline/lib/defaults");
var redux_thunk_1 = require("redux-thunk");
var index_1 = require("./cache/index");
var link_1 = require("./link");
var offline_link_1 = require("./link/offline-link");
/**
 *
 * @param {Function} persistCallback
 * @param {*} effect
 * @returns {Store<NormalizedCache>}
 */
var newStore = function (persistCallback, effect, discard) {
    if (persistCallback === void 0) { persistCallback = function () { return null; }; }
    return redux_1.createStore(redux_1.combineReducers(__assign({ rehydrated: function (state, action) {
            if (state === void 0) { state = false; }
            switch (action.type) {
                case 'REHYDRATE_STORE':
                    return true;
                default:
                    return state;
            }
        } }, index_1.reducer(), offline_link_1.reducer())), window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : {}, redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default), redux_offline_1.offline(__assign({}, defaults_1.default, { persistCallback: persistCallback, persistOptions: {
            whitelist: [index_1.NORMALIZED_CACHE_KEY, 'offline']
        }, effect: effect,
        discard: discard }))));
};
var AWSAppSyncClient = /** @class */ (function (_super) {
    __extends(AWSAppSyncClient, _super);
    /**
     *
     * @param {string} url
     * @param {ApolloClientOptions<InMemoryCache>} options
     */
    function AWSAppSyncClient(_a, options) {
        var url = _a.url, region = _a.region, auth = _a.auth, conflictResolver = _a.conflictResolver, complexObjectsCredentials = _a.complexObjectsCredentials;
        var _this = this;
        _this.hydrated = function () { return _this.hydratedPromise; };
        if (!url || !region || !auth) {
            throw new Error("\n                In order to initialize AWSAppSyncClient, you must specify url, region and auth properties on the config object.\n            ");
        }
        var res;
        _this.hydratedPromise = new Promise(function (resolve, reject) {
            res = resolve;
        });
        var store = newStore(function () {
            _this.aasStore.dispatch({ type: 'REHYDRATE_STORE' });
            res(_this);
        }, function (effect, action) { return offline_link_1.offlineEffect(_this, effect, action); }, offline_link_1.discard(conflictResolver));
        var cache = new index_1.default(store);
        var link = apollo_link_1.ApolloLink.from([
            new link_1.OfflineLink(store),
            new link_1.ComplexObjectLink(complexObjectsCredentials),
            new link_1.AuthLink({ url: url, region: region, auth: auth }),
            apollo_link_1.ApolloLink.split(function (operation) {
                var query = operation.query;
                var _a = apollo_utilities_1.getMainDefinition(query), kind = _a.kind, graphqlOperation = _a.operation;
                var isSubscription = kind === 'OperationDefinition' && graphqlOperation === 'subscription';
                return isSubscription;
            }, apollo_link_1.ApolloLink.from([
                new link_1.NonTerminatingHttpLink('subsInfo', { uri: url }, true),
                new link_1.SubscriptionHandshakeLink('subsInfo'),
            ]), new apollo_link_http_1.HttpLink({ uri: url })),
        ]);
        var newOptions = __assign({}, options, { link: link,
            cache: cache });
        _this = _super.call(this, newOptions) || this;
        _this.aasStore = store;
        return _this;
    }
    /**
     *
     * @param {MutationOptions} options
     * @returns {Promise<FetchResult>}
     */
    AWSAppSyncClient.prototype.mutate = function (options, extraOpts) {
        if (extraOpts === void 0) { extraOpts = {}; }
        var mutation = options.mutation, mutationVariables = options.variables, optimisticResponse = options.optimisticResponse, _a = options.context, origContext = _a === void 0 ? {} : _a;
        var _b = origContext.AASContext, _c = __rest(_b === void 0 ? {} : _b, []), origASAContext = _c === void 0 ? {} : _c;
        var operationDefinition = apollo_utilities_1.getOperationDefinition(mutation);
        var varsInOperation = apollo_utilities_1.variablesInOperation(operationDefinition);
        var variables = Array.from(varsInOperation).reduce(function (obj, key) {
            obj[key] = mutationVariables[key];
            return obj;
        }, {});
        // refetchQueries left out intentionally when !doIt so we don't run them twice
        var refetchQueries = options.refetchQueries, otherOptions = __rest(options, ["refetchQueries"]);
        var doIt = origASAContext.doIt;
        var context = __assign({}, origContext, { AASContext: __assign({}, origASAContext, { mutation: mutation,
                variables: variables,
                optimisticResponse: optimisticResponse,
                refetchQueries: refetchQueries }) });
        return _super.prototype.mutate.call(this, __assign({}, otherOptions, { refetchQueries: doIt ? refetchQueries : undefined, context: context }));
    };
    return AWSAppSyncClient;
}(apollo_client_1.default));
exports.AWSAppSyncClient = AWSAppSyncClient;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-appsync/lib/client.js
// module id = 332
// module chunks = 0